import { makeAutoObservable } from 'mobx';

import { ApiRoutes } from '../../config/ApiRoutes';
import { RootStore } from '../index';

export class UcrApiStore {
  constructor(public rootStore: RootStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });
  }

  getUcr = (params: any = {}) => {
    const {
      Get: { Endpoint, Method },
    } = ApiRoutes.Ucr;
    return this.rootStore.apiStore.call<any>({
      method: Method,
      params: params,
      url: Endpoint,
    });
  };

  addUcr = (data: any) => {
    const {
      Add: { Endpoint, Method },
    } = ApiRoutes.Ucr;
    return this.rootStore.apiStore.call<any>({
      data,
      method: Method,
      url: Endpoint,
    });
  };
}
